import i18n from '@/i18n';
import {
  AbsenceCategory,
  EmployeeEmploymentTypeEnum,
} from '../../../../../api/v1';

export enum AbsenceStatusEnum {
  All = 'All',
  Upcoming = 'Upcoming',
  Ongoing = 'Ongoing',
  Closed = 'Closed',
}
export enum AbsencePaidEnum {
  All = 'All',
  Paid = 'Paid',
  Unpaid = 'Unpaid',
}

export type AbsenceReportsFiltersType = {
  includeArchivedData: boolean;
  locationIds: number[];
  employeeIds: number[];
  jobRoleIds: number[];
  groupIds: number[];
  absenceCategoryIds: AbsenceCategory['id'][];
  employmentTypes: EmployeeEmploymentTypeEnum[];
  paid: AbsencePaidEnum;
  absenceStatus: AbsenceStatusEnum;
};

export const getDefaultAbsenceReportsFilters =
  (): AbsenceReportsFiltersType => ({
    includeArchivedData: false,
    locationIds: [],
    employeeIds: [],
    jobRoleIds: [],
    groupIds: [],
    absenceCategoryIds: [],
    employmentTypes: [],
    paid: AbsencePaidEnum.All,
    absenceStatus: AbsenceStatusEnum.All,
  });

export const AbsenceStatusesList: {
  name: string;
  value: AbsenceStatusEnum;
  id: AbsenceStatusEnum;
}[] = [
  {
    name: i18n.tc('select.all'),
    value: AbsenceStatusEnum.All,
    id: AbsenceStatusEnum.All,
  },
  {
    name: i18n.tc('label.upcoming'),
    value: AbsenceStatusEnum.Upcoming,
    id: AbsenceStatusEnum.Upcoming,
  },
  {
    name: i18n.tc('label.ongoing'),
    value: AbsenceStatusEnum.Ongoing,
    id: AbsenceStatusEnum.Ongoing,
  },
  {
    name: i18n.tc('label.closed'),
    value: AbsenceStatusEnum.Closed,
    id: AbsenceStatusEnum.Closed,
  },
];

export const AbsencePaidList: {
  name: string;
  value: AbsencePaidEnum;
  id: AbsencePaidEnum;
}[] = [
  {
    name: i18n.tc('select.all'),
    value: AbsencePaidEnum.All,
    id: AbsencePaidEnum.All,
  },
  {
    name: i18n.tc('label.paid'),
    value: AbsencePaidEnum.Paid,
    id: AbsencePaidEnum.Paid,
  },
  {
    name: i18n.tc('label.unpaid'),
    value: AbsencePaidEnum.Unpaid,
    id: AbsencePaidEnum.Unpaid,
  },
];
